import { Navigate } from 'react-router'
import { useUserStore } from 'store'

/**
 * Root index route - handles initial routing based on migration status
 *
 * IMPORTANT: This file intentionally avoids importing Chakra components to prevent
 * Chakra v2 from being bundled in the entry point. This ensures migrated users
 * (who use Chakra v3) don't download unnecessary Chakra v2 code on initial page load.
 *
 * Strategy:
 * 1. Read migration status from Zustand store (backed by localStorage, instant)
 * 2. Redirect migrated users to /2/ship (Chakra v3) BEFORE any legacy routes load
 * 3. Redirect non-migrated users to /ship (Chakra v2 legacy UI)
 * 4. Safety net: Route layouts also check migration status via API as authoritative source
 *
 * Why Zustand store (localStorage) instead of API?
 * - Instant redirect (no loading spinner needed)
 * - Prevents legacy route code from executing for migrated users
 * - Route layouts verify via API if localStorage is wrong (failsafe)
 */
export default function () {
  const authToken = useUserStore((state) => state.authToken)
  const migratedAt = useUserStore((state) => state.migratedAt)

  const targetRoute = authToken ? (migratedAt ? '/2/ship' : '/ship') : '/sign-in'

  return <Navigate to={targetRoute} replace />
}
